export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: "性福宝导航是什么？",
    answer: "性福宝导航是一个专为成人用户打造的一站式资源导航平台。我们精心筛选和整理了海量优质的成人内容、娱乐资源及相关服务链接，按照清晰的分类体系进行组织，帮助用户快速找到所需内容，告别繁琐搜索，畅享便捷导航体验。",
  },
  {
    question: "网站上的资源是否安全可靠？",
    answer: "我们对收录的每一个站点都进行了严格的审核和筛选，确保链接的有效性和基本的访问安全性。同时建议用户在访问任何网站时，注意保护个人隐私，使用安全可靠的网络环境，并安装必要的安全防护软件。",
  },
  {
    question: "如何提交新的网站收录申请？",
    answer: "如果您有优质的资源站点希望被收录，可以通过「关于我们」页面的联系表单提交申请。我们的编辑团队会在收到申请后的3-5个工作日内进行审核，审核通过后会及时完成收录。提交时请附上站点名称、URL和简要介绍。",
  },
  {
    question: "网站收录的标准是什么？",
    answer: "我们遵循以下收录标准：1）内容合法合规；2）网站稳定可靠，访问速度良好；3）内容有一定的质量和独特性；4）网站界面设计合理，用户体验良好；5）更新频率正常，非僵尸站点。不符合以上标准的站点将不会被收录。",
  },
  {
    question: "网站上的分类是如何划分的？",
    answer: "我们的分类体系是根据内容类型和用户使用习惯综合设计的。目前包含视频平台、直播平台、图片图库、小说文学、动漫漫画、社区论坛、实用工具和游戏娱乐八大主分类。每个分类下还有更细致的子分类，方便用户精准定位。",
  },
  {
    question: "如何收藏和记录我喜欢的站点？",
    answer: "建议您使用浏览器的书签功能来收藏喜欢的站点。在站点卡片上右键点击链接，选择「添加到书签」即可。您还可以在浏览器中建立文件夹来分类管理收藏的站点，方便日后快速访问。",
  },
  {
    question: "网站内容多久更新一次？",
    answer: "我们的编辑团队每天都会对收录的站点进行检查和更新。新站点收录、热门推荐榜单、最新收录列表等都会实时更新。同时，精品文章栏目每周会发布2-3篇高质量的原创内容，涵盖平台评测、使用技巧、安全指南等多个方面。",
  },
  {
    question: "使用性福宝导航需要付费吗？",
    answer: "完全免费。性福宝导航作为一个导航平台，对所有用户永久免费开放。我们没有会员制度，不收取任何费用。您可以直接浏览和使用平台上收录的所有资源链接。我们通过合理的广告投放来维持平台的运营。",
  },
];